import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// No Firebase initialization here - it's now in firebase.js

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
